export enum ValidationLoadingState {
  waiting,
  success,
  error
}
